import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clients: {},
  offlineLicenses: {},
  permanentLicenses: {},
  temporaryLicenses: {},
  trialLicenses: {},
  productReleases: {},
  productReleasesHistory: {},
  clientsHistory: {},
  offlineLicensesHistory: {},
  permanentLicensesHistory: {},
  temporaryLicensesHistory: {},
  trialLicensesHistory: {},
  history: {},
  adminHistory: {},
  accounts: {},
  accountsHistory: {},
  wrongActivationsHistory: {},
  features: {},
  deviceFeatures: {},
  trialRejectedDevices: {},
  trialRejectedDevicesHistory: {},
  webViewerFeaturePackages: {},
  webViewerServers: {},
  webViewerServersHistory: {},
  webViewerLicenses: {},
  webViewerLicensesHistory: {},
  trialSettingsHistory: {},
  bannedDevices: {},
  banHistory: {},
};

const filterValues = createSlice({
  name: 'filterValues',
  initialState,
  reducers: {
    updateFilterValue: (state, action) => {
      const { objectName, filterName, value } = action.payload;
      if (value === '')
        delete state[objectName][filterName];
      else
        state[objectName][filterName] = value;
    },
    clearObjectFilters: (state, action) => {
      const { objectName } = action.payload;
      state[objectName] = {};
    }
  },
});

const { actions, reducer } = filterValues;

const { updateFilterValue, clearObjectFilters } = actions;

export const setFilterValue = (objectName, filterName, value) => (dispatch) => {
  return new Promise((resolve) => {
    dispatch(updateFilterValue({ objectName, filterName, value }));
    resolve();
  });
};
export const clearFilters = (objectName) => (dispatch) => {
  return new Promise((resolve) => {
    dispatch(clearObjectFilters({ objectName }));
    resolve();
  });
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/userConfigs/filterValuesSlice.js